export default {
  "mb_1_3_0": {
    "productNameMustBeInAtLeastOneLanguage": "ឈ្មោះផលិតផលត្រូវតែមានយ៉ាងហោចណាស់មួយភាសា",
    "finish": "បញ្ចប់"
  }
}